module.exports = __webpack_public_path__ + "static/logo-2d3aabe67b618b12d47ee76d2377c767.svg";